module.exports = __webpack_public_path__ + "media/images/products/category/1-09b02fc184958da9d29c3f55b6f60d01.jpg";